var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","justify-start":"","fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"md2":""}},[_c('AdminNav')],1),_c('v-flex',{attrs:{"md10":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }